import React, { lazy, Suspense } from 'react';
import Container from 'components/UI/Container';
import Title from 'components/UI/Title';
import Button from 'components/UI/Button';
import TagCheckboxGroup from 'components/TagCheckboxGroup';
import Markup from 'components/Markup';
import { useStateModal } from 'utils/hooks';
import { useTrans } from 'utils/localisation';
import { withErrorBoundary } from 'components/ErrorBoundary';
import * as styles from './CtaWithTags.module.scss';

const RequestServicesModal = lazy(() => import('components/Modals/RequestServicesModal'));

function CtaWithTags({ title, subtitle, tagsTitle, services, className }) {
  const t = useTrans(['common', 'ctaWithTags']);
  const { modalState, showModal, hideModal } = useStateModal();
  const id = 'cta-with-tags';
  const preparedServices = services ?? t('services');

  return (
    <>
      <Container className={className}>
        <div className={styles.layout}>
          <div className={styles.titleWrapper}>
            <Title tag="h2" size="h3">
              {title ?? t('title')}
            </Title>
            <Markup tag="p" className={styles.subtitle}>
              {subtitle ?? t('subtitle')}
            </Markup>
          </div>
          <div className={styles.tagsLayout}>
            <Title tag="h3" size="h4">
              {tagsTitle ?? t('tagsTitle')}
            </Title>
            <TagCheckboxGroup className={styles.tagsWrapper} tags={preparedServices} storeId={id} />
            <Button className={styles.button} onClick={showModal} fullWidthMobile>
              {t('buttonText')}
            </Button>
          </div>
        </div>
      </Container>
      <Suspense fallback={null}>
        <RequestServicesModal
          title={t('requestServices')}
          services={preparedServices}
          isOpen={modalState.isOpen}
          closeModalCallback={hideModal}
          animation="show"
          id={id}
          formName={id}
          clearTagsOnClose={false}
        />
      </Suspense>
    </>
  );
}

CtaWithTags.displayName = 'CtaWithTags';

export default withErrorBoundary(CtaWithTags);
